import React, { ReactNode, useState } from 'react';
import { useDetectClickOutside } from 'react-detect-click-outside';

export default function Dropdown(props: {
    children: ReactNode;
    title: ReactNode;
    className?: string;
}) {
    const [dropdown, setDropdown] = useState<boolean>(false);

    const Dropdown = useDetectClickOutside({
        onTriggered: () => {
            setDropdown(false);
        },
    });

    return (
        <>
            <div ref={Dropdown} className={`${props.className}`}>
                <button
                    className={`flex px-2 ${dropdown && 'brightness-75'} hover-effect`}
                    onClick={() => {
                        setDropdown(!dropdown);
                    }}>
                    {props.title}
                </button>
                {dropdown && (
                    <div className={'flex justify-end'}>
                        <div className={'absolute mt-1 overflow-hidden'}>{props.children}</div>
                    </div>
                )}
            </div>
        </>
    );
}
